<template>
  <a-modal
    title="重置支付宝信息"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :width="300"
  >
    <p style="text-align:center;">是否确认重置该用户支付宝信息？</p>
    <template slot="footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button type="primary" @click="handleOk" :loading="confirmLoading">确认</a-button>
    </template>
  </a-modal>
</template>
<script>
import { mapActions } from 'vuex'
import FansApi from '@/api/fans'
// import { message } from 'ant-design-vue'
export default {
  ...mapActions(['WEBSOCKER_ACTIONS_SENDROBOTMSG']),
  data () {
    return {
      visible: false,
      confirmLoading: false,
      data: []
    }
  },
  methods: {
    show (data) {
      this.visible = true
      this.data = data
    },
    handleOk (e) {
      this.confirmLoading = true
      // console.log(this.data.sub_id)
      // console.log(this.data)
      FansApi.resetZfbInfo({
        uid: this.data.uid,
        sub_id: this.data.sub_id
      }).then(res => {
        if (res.code === 1) {
          this.visible = false
          this.confirmLoading = false
          this.$message.info(res.msg)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleCancel () {
      this.visible = false
    }
  }
}
</script>
